// Framework
import { Injectable } from '@angular/core';
// Model
import { Alert } from '../model/app';

@Injectable()

export class AppService {
    appAlerts: Alert[] = [];

    constructor () {}

    // Add an alert to the appAlerts.
    showAlert(msg: string, type: string, dismissible: boolean, timeout: number): void {
        this.appAlerts.push({
            msg: msg,
            type: type,
            dismissible: dismissible,
            timeout: timeout
        });
    }
}